<template>
  <div>
    <van-popup v-model="show" @closed="closed" position="bottom" round
      :style="{ height: showAll ? '90%' : '50%', paddingTop: '0.5rem' }">
      <div style="background-color: white;padding-bottom: 0.5rem;height: 98%;display: flex;flex-direction: column;">
        <div style="font-size: 1.1rem;color: #333333; margin: 0.5rem 1rem;font-weight: 500;">物流跟踪</div>
        <van-tabs v-if="dataList.length > 1" @click="scrollTo" v-model="navIndex"
          style="margin: 0.5rem;">
          <van-tab v-for="(item, index) in dataList" :title="getTitle(index)" :key="index">
          </van-tab>
        </van-tabs>
        <div style="font-size: 0.9rem;color: #666666; margin: 0.5rem 1rem;padding-top: 0.2rem;display: flex;align-items: center;">
          <span>{{ shipperName }}</span>
          <span style="margin-left: 0.8rem;">物流单号：{{ logisticCode }}</span>
          <span @click="copyText(logisticCode)" style="color: #D23B2E;margin-left: 0.5rem;font-size: 0.85rem;">复制</span>
        </div>
        <div style="flex: 1;overflow-y: auto;padding: 0 1rem;">
          <van-steps direction="vertical" :active="active">
            <van-step v-for="(item, index) in getlogisticsList()" :key="index">
              <div :style="{
                fontSize: '0.95rem',
                color: index === 0 ? '#333333' : '#999999',
                lineHeight: '1.4',
                fontWeight: index === 0 ? '500' : 'normal'
              }">
                <template v-for="(part, partIndex) in splitTextWithPhone(item.acceptStation)">
                  <span v-if="part.isPhone" 
                    :key="'phone-' + partIndex"
                    @click="makePhoneCall(part.text)"
                    style="color: #D23B2E;cursor: pointer;">
                    {{ part.text }}
                  </span>
                  <span v-else :key="'text-' + partIndex">{{ part.text }}</span>
                </template>
              </div>
              <div :style="{
                fontSize: '0.85rem',
                color: index === 0 ? '#666666' : '#999999',
                marginTop: '0.3rem'
              }">{{ item.acceptTime }}</div>
            </van-step>
          </van-steps>
        </div>
        <div v-if="logisticsList.length > 2 && !showAll"
          style="display: flex; align-items: center; justify-content: center;margin-top: 1rem;">
          <div class="bottomButton" @click="isShowAll">
            查看全部
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    active: {
      type: Number
    },
    logisticsList: {
      type: Array,
    },
    logisticCode: {
      type: String
    },
    shipperName: {
      type: String
    },
    dataList: {
      type: Array,
    },
    orderNo: {
      type: String
    },
  },
  data() {
    return {
      show: true,
      showAll: false,
      navIndex: 0
    };
  },
  components: {},
  methods: {
    // 将文本分割成普通文本和电话号码
    splitTextWithPhone(text) {
      if (!text) return [];
      // 匹配手机号码和座机号码的正则表达式
      // 手机号：1[3-9]\d{9}
      // 座机号：(\d{3,4}-?)?\d{7,8}
      const phoneRegex = /(1[3-9]\d{9}|(\d{3,4}-?)?\d{7,8})/g;
      const parts = [];
      let lastIndex = 0;
      let match;

      while ((match = phoneRegex.exec(text)) !== null) {
        // 添加电话号码前的普通文本
        if (match.index > lastIndex) {
          parts.push({
            text: text.slice(lastIndex, match.index),
            isPhone: false
          });
        }
        // 添加电话号码
        parts.push({
          text: match[0],
          isPhone: true
        });
        lastIndex = match.index + match[0].length;
      }

      // 添加剩余的普通文本
      if (lastIndex < text.length) {
        parts.push({
          text: text.slice(lastIndex),
          isPhone: false
        });
      }

      return parts;
    },
    makePhoneCall(phone) {
      if (!phone) return;
      // 使用 vant 的 Dialog 确认是否拨打电话
      this.$dialog.confirm({
        title: '拨打电话',
        message: `是否拨打 ${phone}？`,
        confirmButtonText: '拨打',
        cancelButtonText: '取消'
      }).then(() => {
        // 在确认后拨打电话
        window.location.href = `tel:${phone}`;
      }).catch(() => {
        // 取消拨打
      });
    },
    copyText(row) {
      this.$copyText(row).then(
        (e) => {
          this.$Toast('复制成功!')
          console.log(e);
        },
        (err) => {
          this.$Toast('复制失败,请重试!')
          console.log(err);
        }
      );
    },
    scrollTo(index) {
      this.$emit('SelectTab', this.dataList[index], this.orderNo)
    },
    getTitle(val) {
      return '包裹' + (val + 1)
    },
    closed() {
      this.$emit("closed", false);
    },
    getlogisticsList() {
      if (this.showAll) {
        return this.logisticsList
      } else {
        return this.logisticsList.slice(0, 3)
      }
    },
    isShowAll() {
      this.showAll = !this.showAll
    },
  },
  mounted() {
  },
  computed: {},
  watch: {},
};
</script>

<style lang='scss' scoped>
.addressItem {
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  margin-left: 0.8rem;
  margin-right: 0.8rem;
  background-color: white;
  padding: 0.5rem 0.8rem 0 0.8rem;
  border-bottom: 1px solid #fd6e7e;
}

.bottomButton {
  width: 8rem;
  height: 2.2rem;
  line-height: 2.2rem;
  text-align: center;
  background: #F5F5F5;
  border-radius: 1.1rem;
  color: #666666;
  font-size: 0.9rem;
}

::v-deep .van-tab {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0;
  color: #666666;
  font-size: 0.9rem;
  line-height: 1.8rem;
  margin-left: 0.5rem;
  cursor: pointer;
  max-width: 4rem;
  min-width: 4rem;
}

::v-deep .van-tabs--line .van-tabs__wrap {
  height: 2.2rem;

  .van-tabs__nav {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    background-color: #00000000;
    -webkit-user-select: none;
    user-select: none;
  }
}

::v-deep .van-tab--active {
  color: white;
  font-weight: 500;
  background: #D23B2E;
  border-radius: 1.1rem;
  height: 1.8rem;
  margin-top: 0.2rem;
  max-width: 4rem;
}

::v-deep .van-tabs__line {
  display: none;
}

::v-deep .van-steps--vertical {
  padding: 0 0 1rem 1.5rem;
}

::v-deep .van-step__circle {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #D23B2E;
}

::v-deep .van-step__line {
  background-color: #EEEEEE;
}

::v-deep .van-step--active .van-step__circle {
  background-color: #D23B2E;
}

::v-deep .van-step--active .van-step__line {
  background-color: #D23B2E;
}

::v-deep .van-step--inactive .van-step__circle {
  background-color: #CCCCCC;
}

::v-deep .van-step--inactive .van-step__line {
  background-color: #EEEEEE;
}

::v-deep .van-step--active .van-step__title {
  color: #333333;
  font-weight: 500;
}

::v-deep .van-step--inactive .van-step__title {
  color: #999999;
  font-weight: normal;
}
</style>